import { HeaderNotifications } from './header-notifications';
import type { HeaderNotificationItem } from './notification-types';
import { useHeaderNotifications } from './use-header-notifications';

type HeaderNotificationControllerProps = {
  userId?: string;
  initialNotifications?: HeaderNotificationItem[];
  className?: string;
};

/** Mounted only for an authenticated session. Both layouts share one source. */
export function HeaderNotificationController({
  userId,
  initialNotifications,
  className,
}: HeaderNotificationControllerProps) {
  const source = useHeaderNotifications(true, userId);

  return (
    <HeaderNotifications
      initialNotifications={initialNotifications}
      source={source}
      className={className}
    />
  );
}
